<div class="accountView verticalCenterView">

    <span class="accountView__userDetails" *ngIf="mainService.userService.isAuthenticated()">
        <span>{{ this.mainService.userService.getUserEmail() }}</span>
        <div class="accountView__premiumIcon" *ngIf="ShowSpecialBadge"></div>
    </span>
    

    <mat-list class="accountView__list" role="list">
      <mat-list-item role="listitem">
        <button mat-raised-button [routerLink]="['/my-ads']">My ads<mat-icon aria-hidden="true">dashboard</mat-icon></button>
      </mat-list-item>
      <mat-list-item role="listitem" *ngIf="enableSubscription">
        <button mat-raised-button [routerLink]="['/subscription-information']">Subscription<mat-icon aria-hidden="true">subscriptions</mat-icon></button>
      </mat-list-item>
      <mat-list-item role="listitem">
        <button mat-raised-button [matBadgeHidden]="newMessageCount <= 0" matBadge="{{ newMessageCount }}" matBadgeColor="accent"
                matBadgeSize="small" [routerLink]="['/conversations']">
          Inbox<mat-icon aria-hidden="true">chat</mat-icon>
        </button>
      </mat-list-item>
      <mat-list-item role="listitem" *ngIf="isAdminOrDemo">
        <button mat-raised-button (click)="showAllNonDemoAds()">All non demo ads<mat-icon aria-hidden="true">book</mat-icon></button>
      </mat-list-item>
      <mat-list-item role="listitem">
        <button mat-raised-button (click)="showDeleteAccountModal()">Delete account<mat-icon aria-hidden="true">person_remove</mat-icon></button>
      </mat-list-item>
      <mat-list-item role="listitem">
        <button mat-raised-button (click)="logout()">Logout<mat-icon aria-hidden="true">exit_to_app</mat-icon></button>
      </mat-list-item>
    </mat-list>
</div>
